import styles from "../assets/styles/componenets/homesection.module.css";
import { useState } from "react";
import { useEffect, useRef } from "react";
import Wordline from "../assets/images/wordline.svg";
import background from "../assets/images/back2-min.png";

export default function HomeSection() {
    const [scrolled, setScrolled] = useState(false);

    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            }
        };

        window.addEventListener("scroll", handleScroll);

        const headerObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.7 }
        );

        if (ref.current) {
            headerObserver.observe(ref.current);
        }
    });

    return (
        <div className={styles.main} id="home">
            <section className={styles.heroSection}>
                <div>
                    <h1>
                        Կերտեք Ձեր Ապագան մեր Իրավաբանական{" "}
                        <span>
                            Դպրոցում։<img src={Wordline} alt="line"></img>
                        </span>
                    </h1>
                    <p>
                        Միացեք իրավագիտության ոլորտում լավագույնը կերտող
                        համայնքին: Մեր նորարարական դասընթացները և
                        փորձառու դասախոսները կնպաստեն ձեր իրավաբանական կարիերայի
                        հաջողակ ձևավորմանն ու աննախադեպ աճին:
                    </p>
                    <a href="tel:+37496640494">
                        <p>Զանգահարել</p>
                        <div></div>
                    </a>
                </div>
            </section>
            <section
                ref={ref}
                className={`${styles.gallerySection} ${
                    isVisible && styles.visible
                }`}
            >
                <div className={styles.backgroundtop}></div>
                <img src={background} alt="logo"></img>
            </section>
            {!scrolled && (
                <a href="#lessons" className={styles.scrollDown}>
                    <i className="fa-solid fa-arrow-down"></i>
                </a>
            )}
        </div>
    );
}
